import { Flex, Text, useColorModeValue } from "@chakra-ui/react";
import CardHeader from "components/Card/CardHeader";
import { useTranslation } from "react-i18next";
import { calculateAge } from "utils/utils";

function ListPageCardBeneficiaryHeader({ beneficiaryData }) {
  const textColor = useColorModeValue("gray.700", "white");
  const { t } = useTranslation();

  const { nome, ano_nascimento } = beneficiaryData;
  const idade = calculateAge(ano_nascimento);

  return (
    <CardHeader px="22px" mb="24px">
      <Flex gap="1" direction="column">
        {nome && (
          <Text color={textColor} fontSize="sm">
            <strong>{t("parking-credentials.fields.beneficiary.name")}:</strong> {nome}
          </Text>
        )}
        {ano_nascimento && (
          <Text color={textColor} fontSize="sm">
            <strong>{t("parking-credentials.fields.beneficiary.date-of-birth")}:</strong> {ano_nascimento}
          </Text>
        )}
        {idade !== null && (
          <Text color={textColor} fontSize="sm">
            <strong>{t("parking-credentials.fields.beneficiary.age")}:</strong> {idade}
          </Text>
        )}
      </Flex>
    </CardHeader>
  );
}


export default ListPageCardBeneficiaryHeader;